import { API } from "../../../utils/Apis";
import {
  deleteMessage,
  getConversationList,
  getMessages,
  getNotifications,
  sendMessage,
  updateMessage,
  updatNotifications,
} from "../Reducers/MessagesReducer";
import { AppDispatch } from "../Store";

export const getConversationAction = (data: object, dispatch: AppDispatch) =>
  API.getUserConversations().then((res: any) => {
    if (res.type === "success") {
      const updateList = data.page === 1;

      dispatch(getConversationList({ items: res.data.chats, updateList }));
    }
    return res;
  });

export const getMessagesAction = (data: object, dispatch: AppDispatch) =>
  API.getUserChat(data).then((res: any) => {
    if (res.type === "success") {
      const updateList = data.page === 1;
      dispatch(getMessages({ items: res.data.messages, updateList }));
    }
    return res;
  });
export const sendMessageAction = (data: object, dispatch: AppDispatch) =>
  API.sendUserMessage(data).then((res: any) => {
    if (res.type === "success") {
      dispatch(sendMessage({ item: res.data }));
    }
    return res;
  });

export const updateMessageAction = (data: object, dispatch: AppDispatch) =>
  API.updateUserMessage(data).then((res: any) => {
    if (res.type === "success") {
      dispatch(updateMessage({ item: res.data }));
    }
    return res;
  });

export const deleteMessageAction = (data: object, dispatch: AppDispatch) =>
  API.deleteUserMessage(data).then((res: any) => {
    if (res.type === "success") {
      dispatch(deleteMessage({ id: data.id, updateList: true }));
    }
    return res;
  });

export const getNotificationsAction = (data: object, dispatch: AppDispatch) =>
  API.getNotifications(data).then((res: any) => {
    if (res.type === "success") {
      dispatch(getNotifications({ items: res.data }));
    }
    return res;
  });

export const markReadNotificationAction = (
  data: object,
  dispatch: AppDispatch
) =>
  API.readNotification(data).then((res: any) => {
    if (res.type === "success") {
      dispatch(updatNotifications({ id: data.id }));
    }
    return res;
  });

export const clearMessageListAction = (dispatch: AppDispatch) => {
  dispatch(getMessages({ items: [], updateList: true }));
};
